import { useState } from "react";
import { Element, Link } from "react-scroll";
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import mlabScreenshot from "..//Assets/Images/mlabScreenshot.png";

const navigation = [
  { name: "Product", href: "#" },
  { name: "Features", href: "#" },
  { name: "Marketplace", href: "#" },
  { name: "Company", href: "#" },
];

export default function Hero() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <Element name="home">
      <div className="bg-white">
        <div className="relative isolate pt-14">
          <div className="mx-auto max-w-7xl px-6 py-4 lg:flex lg:gap-x-10 lg:px-8 ">
            <div className="mx-auto max-w-2xl lg:mx-0 lg:flex-auto">
              <h1 className="mt-10 max-w-lg text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
                The mLabApp project has completed.
              </h1>
              <p className="mt-6 text-lg leading-8 text-gray-600">
                We'd like to thank all of the participants for making this
                important work possible. We'd also like to acknowledge the
                effort from the study team in recruiting, developing, and
                analyzing data. Feel free to take a look at the results below to
                learn more.
              </p>
              <div className="mt-10 flex items-center gap-x-6">
                <Link
                  to="results"
                  key="results"
                  smooth={true}
                  duration={500}
                  className="rounded-md bg-blue-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                >
                  See Results
                </Link>
                <Link
                  to="contactus"
                  key="contactus"
                  smooth={true}
                  duration={500}
                  className="rounded-md border-blue-500 border-2 px-3.5 py-2.5 text-sm font-semibold bg-white shadow-sm hover:bg-blue-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                >
                  Contact Us
                </Link>
              </div>
            </div>
            <div className="mt-16 sm:mt-24 lg:mt-0 lg:flex lg:flex-auto lg:justify-center lg:flex-shrink-0 lg:flex-grow">
              <img src={mlabScreenshot} className="h-[36rem]" alt="Logo" />
            </div>
          </div>
        </div>
      </div>
    </Element>
  );
}
